var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.90001 0L9.90001 2L5.30001 6.6H18.7V9.4H5.30001L9.90001 14L7.90001 16L-0.099987 8",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.90001 0L9.90001 2L5.30001 6.6H18.7V9.4H5.30001L9.90001 14L7.90001 16L-0.099987 8",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.7,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 18.7 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/icon_arrow_left.988c7a7306621e8220cd8f37d5a07d78.svg";
export { ForwardRef as ReactComponent };